import React from 'react';
import CustomInvEdit from '../invoice/CustomInvEdit';

const CustomInvoiceEdit = () => {
    return (
        <CustomInvEdit/>
    );
};

export default CustomInvoiceEdit;